"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DefaultEventImageUrls = void 0;
var DefaultEventImageUrls;
(function (DefaultEventImageUrls) {
    DefaultEventImageUrls["GeneralEvent"] = "https://storage.googleapis.com/sellout-assets/default-images/event/general-event.jpeg";
    DefaultEventImageUrls["Concert"] = "https://storage.googleapis.com/sellout-assets/default-images/event/concert.jpeg";
})(DefaultEventImageUrls = exports.DefaultEventImageUrls || (exports.DefaultEventImageUrls = {}));
;
//# sourceMappingURL=DefaultEventImageUrls.js.map